import { Modal } from "Components/Modals/Modal";

import AttentionIcon from "Assets/Images/atention.svg";
import { Box } from "styles/globalComponents";
import UploadAreaAnnex from "Components/Form/UploadAnnex";

interface ModalUploadFilesIAProps {
  isOpen: boolean;
  closeModal: () => void;
  onUploadFiles: (files: File[]) => void;
}

export const ModalUploadFilesIA = ({
  closeModal,
  isOpen,
  onUploadFiles,
}: ModalUploadFilesIAProps) => {
  return (
    <Modal
      closeOverlay={false}
      closeIcon={false}
      requestClose={closeModal}
      isOpen={isOpen}
      modalIcon={AttentionIcon}
      renderHeading={() => <h2> Upload de arquivos</h2>}
      renderDescription={() => (
        <p>
          Para criar o orçamento com IA, faça o upload do(s) pedido(s) médico(s)
        </p>
      )}
      renderActions={() => (
        <Box>
          <Box>
            <UploadAreaAnnex
              only={false}
              uploadFile={onUploadFiles}
              formDataFileString="documents[]"
              fileAccept=".jpeg, .png, .pdf, .jpg"
              importPath=""
              multi
              children={
                <button className="button transparent-btn" onClick={closeModal}>
                  VOLTAR
                </button>
              }
            />
          </Box>
        </Box>
      )}
    />
  );
};
